import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
// import { Button } from './ui/button';
// import { Input } from './ui/input';
// import { Textarea } from './ui/textarea';
// import { useToast } from '../hooks/use-toast';

export const Contact = () => {
  // const { toast } = useToast();
  // const [formData, setFormData] = useState({
  //   name: '',
  //   email: '',
  //   phone: '',
  //   company: '',
  //   message: ''
  // });

  // const handleChange = (e) => {
  //   setFormData({
  //     ...formData,
  //     [e.target.name]: e.target.value
  //   });
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   // Mock submission
  //   toast({
  //     title: 'Request Submitted!',
  //     description: 'Thank you for contacting us. We will get back to you soon.'
  //   });
  //   // Reset form
  //   setFormData({
  //     name: '',
  //     email: '',
  //     phone: '',
  //     company: '',
  //     message: ''
  //   });
  // };

  const contactInfo = [
    {
      icon: MapPin,
      title: 'Visit Us',
      content: 'No. 48/5, Arcot Road, Saligramam, Chennai 600 093.',
      link: 'https://www.google.com/maps/dir//Majestic+garden,+48,+Muthukumarappa+St,+Velayutham+Colony,+Saligramam,+Chennai,+Tamil+Nadu+600093,+India/@13.0485687,80.1987088,18z/data=!4m18!1m8!3m7!1s0x3a52670004051669:0xc811c257c059f597!2sMajestic+garden!8m2!3d13.0485687!4d80.200125!15sClJGbGF0IE5vLiAyMCwgJ01hamVzdGljIEdhcmRlbicsIE5vLiA0OC81LCBBcmNvdCBSb2FkLCBTYWxpZ3JhbWFtLCBDaGVubmFpIDYwMCAwOTMukgETY29uZG9taW5pdW1fY29tcGxleKoBvwEQASpMIkhmbGF0IG5vIDIwIG1hamVzdGljIGdhcmRlbiBubyA0OCA1IGFyY290IHJvYWQgc2FsaWdyYW1hbSBjaGVubmFpIDYwMCAwOTMoADIfEAEiG7gaMxYjetW3B2kcsxophAwxpT5aP5XJqF_LzjJMEAIiSGZsYXQgbm8gMjAgbWFqZXN0aWMgZ2FyZGVuIG5vIDQ4IDUgYXJjb3Qgcm9hZCBzYWxpZ3JhbWFtIGNoZW5uYWkgNjAwIDA5M-ABAA!16s%2Fg%2F11w9_hc9sk!4m8!1m0!1m5!1m1!1s0x3a52670004051669:0xc811c257c059f597!2m2!1d80.1999876!2d13.0485812!3e4?hl=en&entry=ttu&g_ep=EgoyMDI1MTAxMy4wIKXMDSoASAFQAw%3D%3D'
    },
    {
      icon: Mail,
      title: 'Email Us',
      content: 'info@assurefmservices.com',
      link: 'mailto:info@assurefmservices.com'
    },
    {
      icon: Phone,
      title: 'Call Us',
      content: '+91 44 2489 5042 / 4606 4662',
      link: 'tel:+914424895042'
    },
    
  ];

  return (
    <section id="contact" className="py-20 bg-white dark:bg-gray-800">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block bg-emerald-100 dark:bg-emerald-900 text-emerald-600 dark:text-emerald-300 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Contact Us
          </div>
          <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-6">
            Get in Touch with Us
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-400">
            Have questions? We're here to help. Request a quote or learn more about our services.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-12 max-w-6xl mx-auto">
          {/* Contact Info Cards */}
          <div className="lg:col-span-12 space-y-6 mb-12 lg:mb-0 grid lg:grid-cols-3 gap-6">
            {contactInfo.map((item, index) => {
              const Icon = item.icon;
              return (
                <a
                  key={index}
                  href={item.link} target='_blank'
                  className="block bg-gradient-to-br from-blue-50 to-emerald-50 dark:from-gray-900 dark:to-gray-800 rounded-2xl p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100 dark:border-gray-700"
                >
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-emerald-500 rounded-xl flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400">{item.content}</p>
                </a>
              );
            })}
          </div>

          {/* Contact Form */}
          {/* <div className="lg:col-span-2">
            <form onSubmit={handleSubmit} className="bg-gray-50 dark:bg-gray-900 rounded-2xl p-8 shadow-xl">
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Full Name *
                  </label>
                  <Input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="John Doe"
                    required
                    className="w-full"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Email Address *
                  </label>
                  <Input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="john@company.com"
                    required
                    className="w-full"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Phone Number
                  </label>
                  <Input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+91 98765 43210"
                    className="w-full"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Company Name
                  </label>
                  <Input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Your Company"
                    className="w-full"
                  />
                </div>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Message *
                </label>
                <Textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your facility management needs..."
                  rows={6}
                  required
                  className="w-full"
                />
              </div>

              <Button
                type="submit"
                size="lg"
                className="w-full bg-gradient-to-r from-blue-600 to-emerald-600 hover:from-blue-700 hover:to-emerald-700 text-white font-semibold"
              >
                <Send className="mr-2 w-5 h-5" />
                Send Message
              </Button>
            </form>
          </div> */}
        </div>
      </div>
    </section>
  );
};